import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";
import "./ImageSwiper.css";

// Import the slider images as an array
const sliderImages = [
  ...Array.from({ length: 4 }, (_, index) =>
    require(`../images/slider${index + 19}.jpg`)
  ),
  ...Array.from({ length: 18 }, (_, index) =>
    require(`../images/slider${index + 1}.jpeg`)
  ),
];

SwiperCore.use([Navigation, Pagination, Autoplay]);

const ImageSwiper = () => {
  const customPrevButton = (
    <IoIosArrowBack size={30} color="#fff" className="swiper-button-prev" />
  );

  const customNextButton = (
    <IoIosArrowForward
      size={30}
      color="#fff"
      className="swiper-button-next text-green-500"
    />
  );

  return (
    <Swiper
      navigation={{
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      }}
      loop
      speed={1000}
      autoplay={{ delay: 1000 }}
      className="swiper1 p-8"
    >
      {sliderImages.map((image, index) => (
        <SwiperSlide key={index}>
          <img className="w-[500px]" src={image} alt="" />
        </SwiperSlide>
      ))}
      <div className="swiper-button-prev-custom">{customPrevButton}</div>
      <div className="swiper-button-next-custom">{customNextButton}</div>
    </Swiper>
  );
};

export default ImageSwiper;
